import '.i9{font-size:2.875rem;}.ssr-plugin'
import { CardWrapper } from '@app/components/blocks/card/CardWrapper'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { styled } from 'inlines'
import { useState } from 'react'

export type PhaseCardProps = {
  icon: string
  title: string
  description: string
  selected: boolean
  onClick: VoidFunction
}

export const PhaseCard = ({
  icon,
  title,
  description,
  selected,
  onClick,
}: PhaseCardProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <CardWrapper
      onClick={onClick}
      style={{
        border: `1px solid var(${selected ? '--brand-secondary' : '--gray-200'})`,
      }}
    >
      <span
        onMouseOver={() => setExpanded(true)}
        onMouseOut={() => setExpanded(false)}
      >
        <Row gap="1.5rem" alignItems="center">
          <div className="i9">{icon}</div>
          <Column gap="0.5rem">
            <Title.H4>{title}</Title.H4>
            <Text.Medium
              style={{
                display: '-webkit-box',
                WebkitLineClamp: expanded ? 'none' : 2,
                maxHeight: expanded ? '7rem' : '3.5rem',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-out',
              }}
            >
              {description}
            </Text.Medium>
          </Column>
        </Row>
      </span>
    </CardWrapper>
  )
}
